module.exports = __webpack_public_path__ + "img/gz2.d9624dea.jpg";